import Enum from "../Enum";

export default Enum.create( {
	GOAL_SCREEN: "Goal Screen",
	IN_MEETING: "In-meeting",
	TEAM_SPACES: "Team Spaces",
	ONE_ON_ONE_SPACES: "1:1 Spaces",
	ONE_ON_ONE_LIST: "1:1 List",
	PRIMARY_NAV: "Primary Nav",
	SETTINGS: "Settings",
	TRIAL_END_DIALOG: "Trial End Dialog",
} );
